import React from 'react';
import { Box, Container } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import CreatePaymentLinkForm from './CreatePaymentLinkForm';
import useStyles from './styles';

function PaymentLinkCreateView() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Crear Link de Pago">
      <Container maxWidth={false}>
        <Header />
        <Box mt={3}>
          <CreatePaymentLinkForm />
        </Box>
      </Container>
    </Page>
  );
}

export default PaymentLinkCreateView;
